import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getEmployeeWithNoCrew,
  insertCrew,
  checkNomEquipe,
} from "../../../../services/RHService/CrewService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddCrew = () => {
  const [employeeError, setEmployeeError] = useState("");
  const [crew, setCrew] = useState([]);
  const [formData, setFormData] = useState({});

  const handleInputChange = async (event) => {
    try {
      const target = event.target;
      const name = target.name;
      setFormData({ ...formData, [name]: target.value });
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const names = await getEmployeeWithNoCrew(getCurrentUserId());
        setCrew(names.data?.success);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.nomEquipe) {
      toastr.error("Veuillez renseigner tous les champs.");
    } else {
      if (!formData.idChefEquipe || formData.idChefEquipe === "equipe") {
        setEmployeeError("Veuillez saisir un chef d'équipe");
      } else {
        setEmployeeError("");
        const checkNomEquipeExist = await checkNomEquipe(
          formData.nomEquipe,
          getCurrentUserId()
        );
        console.log(checkNomEquipeExist);

        if (checkNomEquipeExist.data?.success >= 1) {
          toastr.error("Le nom d'équipe déja existe.");
        } else {
          formData.idUser = getCurrentUserId();

          insertCrew(formData)
            .then((response) => {
              toastr.success("Equipe ajouter avec succée.");
            })
            .catch((error) => {
              console.log(error.response.data);
              toastr.error("Erreur lors de l'insertion.");
            });
        }
      }
    }
  };
  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Ajouter une équipe</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/crewList">Liste des équipes</Link>
                </li>
                <li className="breadcrumb-item active">
                  Création d'une equipe
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Ajouter une équipe</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label>Nom d'équipe</label>
                          <input
                            type="text"
                            name="nomEquipe"
                            value={formData.nomEquipe}
                            onChange={handleInputChange}
                            className="form-control form-control-border"
                            placeholder="Nom"
                          />
                        </div>
                        <div className="form-group">
                          <label>Chef d'equipe </label>
                          <select
                            className="custom-select form-control-border"
                            name="idChefEquipe"
                            value={formData.idChefEquipe}
                            onChange={handleInputChange}
                          >
                            <option value="equipe">
                              --Choisir un Chef d'équipe--
                            </option>
                            {crew.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.firstName} {c.lastName}
                              </option>
                            ))}
                          </select>
                        </div>
                        {employeeError && (
                          <p style={{ color: "red" }}>{employeeError}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-dark col-md-3 float-right"
                      style={{ width: "auto" }}
                    >
                      Ajouter
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddCrew;
